import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import GameJoin from '~/play/GameJoin';

export const Route = createFileRoute('/games/$id/join')({
  component: GameJoinRoute,
});

function GameJoinRoute() {
  const { id } = Route.useParams();
  return <GameJoin id={id} />;
}
